import { useId } from 'react';
import TimeSeriesChart, { chartColor } from '../shared/TimeSeriesChart';

/**
 * Tiny inline sparkline for an account row.
 *
 * The same chart every other trend uses, with the pointer affordances off —
 * the row itself is the click target, so a crosshair here would be noise.
 * Returns an empty spacer when there is no signal, so rows stay aligned.
 * A soft fill in the line's colour sits under it; each sparkline names its
 * own gradient, or every row would paint with the first row's colour.
 */
export default function AccountSparkline({ values, color = chartColor('redesign.accent.green'), width = 70, height = 20 }) {
  const key = `spark${useId().replace(/[^a-zA-Z0-9]/g, '')}`;
  const hasSignal = values && values.some((v) => v > 0);
  if (!hasSignal) return <TimeSeriesChart series={[]} width={`${width}px`} height={height} my={0} flexShrink={0}
                                          interactive={false} showHoverLabel={false} showEndDots={false} />;

  return (
    <TimeSeriesChart
      series={[{ key, values, color, strokeWidth: 1.5, fill: true }]}
      width={`${width}px`}
      height={height}
      my={0}
      flexShrink={0}
      maxPoints={14}
      interactive={false}
      showHoverLabel={false}
      showEndDots={false}
      showZeroLine={false}
    />
  );
}
